import { render } from "./BranchCredits.vue?vue&type=template&id=a84591aa&ts=true"
import script from "./BranchCredits.vue?vue&type=script&lang=ts"
export * from "./BranchCredits.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__